import { attachDialog } from '../../util/dialog_helpers.js';
import { attachEventHandlers } from '../mixins/PreventModalEscape.js';

export const showSuspendedAccountDialog = async () => {
  const response = await fetch('/shared/dialogs/account_suspended_dialog');
  if (!response.ok) {
    console.error('Failed to fetch dialog template:', response.status, response.statusText);
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const template = await response.text();
  const dialog = attachDialog(template);

  attachEventHandlers(dialog);
};
